import request from '../../request';

function initalState() {
  return {
    loading: false,
    data: [],
    form: {
      /* identity_proof: [],
      registration_proof: [],
      articles_of_association: [],
      share_holder_declaration: [], */
    },
  };
}

export default {
  namespaced: true,
  state: initalState(),
  mutations: {
    setState(state, initialState) {
      Object.assign(state, initialState);
    },
    setLoading(state, loading) {
      Object.assign(state, { loading });
    },
    setData(state, data) {
      Object.assign(state, { data });
    },
    createFormState(state, data) {
      const form = {};
      data.forEach((doc) => {
        form[doc.type] = {
          id: doc.id,
          errors: {},
        };
      });
      Object.assign(state, { form });
    },
    setFormErrors(state, payload) {
      Object.assign(state.form[payload.key], { errors: payload.errors });
    },
  },
  actions: {
    reset(context) {
      return new Promise((resolve) => {
        context.commit('setState', initalState());
        resolve();
      });
    },
    get(context) {
      return new Promise((resolve) => {
        context.commit('setLoading', true);
        const url = `${process.env.API_URL}kyc`;
        request.make({
          url,
          type: 'GET',
        }, (err, res) => {
          if (res.status === 200 || res.status === 304) {
            context.commit('createFormState', res.body.data);
            context.commit('setData', res.body.data);
            context.commit('setLoading', false);
            resolve();
          }
        });
      });
    },
    setFormErrors(context, payload) {
      context.commit('setFormErrors', payload);
    },
    removePage(context, id) {
      return new Promise((resolve) => {
        const url = `${process.env.API_URL}kyc_page`;
        request.make({
          url,
          type: 'DELETE',
          data: { id },
        }, (err, res) => {
          if (res.status === 204) {
            resolve();
          }
        });
      });
    },
    sendForReview(context) {
      return new Promise((resolve) => {
        const url = `${process.env.API_URL}kyc`;
        request.make({
          url,
          type: 'PATCH',
          data: { status: 'VALIDATION_ASKED', type: 'ALL', username: context.rootState.user.data.username },
        }, (err, res) => {
          if (res.status === 200 || res.status === 204) {
            resolve();
          }
        });
      });
    },
    clearDocument(context, type) {
      return new Promise((resolve) => {
        const url = `${process.env.API_URL}kyc`;
        const data = {
          username: context.rootState.user.data.username,
          type: type.toUpperCase(),
        };

        request.make({
          type: 'DELETE',
          url,
          data,
        }, () => {
          resolve();
        });
      });
    },
  },
  getters: {
    isReadyForSending(state) {
      let countValidationsAsked = 0;
      let isReadyForSending = true;
      state.data.forEach((doc) => {
        if (doc.pages.length === 0) {
          isReadyForSending = false;
        }
        if (doc.status === 'VALIDATION_ASKED') {
          countValidationsAsked += 1;
        }
      });
      if (countValidationsAsked === state.data.length) {
        isReadyForSending = false;
      }
      return isReadyForSending;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/promoter/kyc.js